"use client";

import { c as _c } from "react/compiler-runtime";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import React, { useMemo } from "react";
import { useAuth } from "@/components/auth/Auth";
import useCreateModalState, { CREATE_DIRECT_MESSAGE_VALUE } from "@/hooks/useCreateModalState";
const BrainLeftSidebarCreateADirectMessageButton: React.FC = () => {
  const $ = _c(8);
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const {
    getHrefForMode
  } = useCreateModalState();
  connectedProfile?.handle;
  const isConnectedIdentity = !!connectedProfile?.handle && !activeProfileProxy;
  let t0;
  bb0: {
    if (isConnectedIdentity) {
      t0 = "Create DM";
      break bb0;
    }
    t0 = "Direct Message";
  }
  const label = t0;
  let t1;
  if ($[0] !== getHrefForMode) {
    t1 = getHrefForMode(CREATE_DIRECT_MESSAGE_VALUE);
    $[0] = getHrefForMode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faPaperPlane} className="tw-size-3 -tw-ml-1.5 tw-flex-shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <span>{label}</span>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <Link href={t1} className="tw-no-underline tw-ring-1 tw-ring-inset tw-ring-iron-700 desktop-hover:hover:tw-ring-iron-700 tw-text-iron-300 tw-flex tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-lg tw-py-2 tw-px-4 tw-text-xs tw-bg-iron-800 desktop-hover:hover:tw-text-primary-400 tw-font-semibold tw-transition-all tw-duration-300">{t2}{t3}</Link>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default BrainLeftSidebarCreateADirectMessageButton;